import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchDollar, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { BIZDEV_NAV } from './nav';

const Prospecting: React.FC = () => {
    const { api } = useInternalApi();
    const [uncovered, setUncovered] = useState<any[]>([]);
    const [expansion, setExpansion] = useState<any[]>([]);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Prospecting - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('bizdev-api/prospecting/').then(r => {
            if (r.data?.status === 'success') {
                setUncovered(r.data.data.uncovered_counties || []);
                setExpansion(r.data.data.expansion_within_accounts || []);
                setNote(r.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="business_development" subNav={BIZDEV_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faSearchDollar} className="me-2 text-primary" />Prospecting</h2>
            <p className="text-muted mb-4">Concrete gaps worth acting on, derived from live records</p>

            <div className="alert alert-secondary small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <div className="row">
                    <div className="col-lg-5 mb-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-header bg-white">
                                <strong>Counties with no presence</strong> <span className="badge bg-warning ms-2">{uncovered.length}</span>
                            </div>
                            <div className="card-body p-0">
                                {uncovered.length === 0 ? (
                                    <div className="text-center py-4 text-muted">Every county has some presence.</div>
                                ) : (
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light"><tr><th>County</th><th>Towns</th></tr></thead>
                                        <tbody>
                                            {uncovered.map(c => (
                                                <tr key={c.county}><td>{c.county}</td><td>{c.towns}</td></tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 mb-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-header bg-white">
                                <strong>Expansion inside existing accounts</strong> <span className="badge bg-info ms-2">{expansion.length}</span>
                            </div>
                            <div className="card-body p-0">
                                {expansion.length === 0 ? (
                                    <div className="text-center py-4 text-muted">All accounts have clinics and staff onboarded.</div>
                                ) : (
                                    <table className="table table-hover align-middle mb-0">
                                        <thead className="table-light"><tr><th>Institution</th><th>Town</th><th>Clinics</th><th>Staff</th><th>Opportunity</th></tr></thead>
                                        <tbody>
                                            {expansion.map(e => (
                                                <tr key={e.institution_id}>
                                                    <td><strong>{e.name}</strong></td>
                                                    <td className="small">{e.town || '—'}</td>
                                                    <td>{e.clinics}</td>
                                                    <td>{e.staff}</td>
                                                    <td className="small">{e.opportunity}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </InternalShell>
    );
};

export default Prospecting;
